import { VarKey } from '../../Variables/Generated/VarKey.Data'
import { CoreType } from '../../Core/Core.Interfaces'
import { GenericTableSchemaInterface } from '../../Table/Table.Interfaces'

export const ChucksTestTable: GenericTableSchemaInterface = {
  id: 'chucks-test-table',
  name: "Chuck's Test Table",
  description: 'This is a test table for Chuck',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'First Name',
      variable: VarKey.UserName
    },
    c02: {
      name: 'Favorite Food'
    }
  }
}
